import { CookieManager } from "./CookieManager";

export class Tenant
{
	static ID = {
		FunUS: 159,
		FunUK: 167,
		FunAU: 170,
		HalloweenCostumesUS: 13,
		HalloweenCostumesCA: 140,
		HalloweenCostumesUK: 164,
		HalloweenCostumesAU: 165,
		HalloweenCostumesEU: 171,
		HalloweenCostumesMX: 173,
		HalloweenUS: 184,
		FancyDressCOM: 187,
		JokersMasqueradeGB: 188
	};

	static get CurrencyID(): string
	{
		const currencyCookie = CookieManager.Cookies.Currency;
		return CookieManager.GetCookie(currencyCookie.Key, currencyCookie.CurrencyID);
	}

	static get CurrencySymbol(): string
	{
		const currencyCookie = CookieManager.Cookies.Currency;
		return CookieManager.GetCookie(currencyCookie.Key, currencyCookie.CurrencySymbol);
	}

	static get DomainProjectID(): number
	{
		const visitorCookie = CookieManager.Cookies.Visitor;
		return parseInt(CookieManager.GetCookie(visitorCookie.Key, visitorCookie.DomainProjectID), 10);
	}

	static get ShortName(): string
	{
		switch (this.DomainProjectID)
		{
			case this.ID.FancyDressCOM:
				return "FancyDressCOM";
				break;
			case this.ID.FunUS:
				return "FunUS";
				break;
			case this.ID.FunAU:
				return "FunAU";
				break;
			case this.ID.FunUK:
				return "FunUK";
				break;
			case this.ID.HalloweenUS:
				return "HalloweenUS";
				break;
			case this.ID.HalloweenCostumesUS:
				return "HalloweenCostumesUS";
				break;
			case this.ID.HalloweenCostumesCA:
				return "HalloweenCostumesCA";
				break;
			case this.ID.HalloweenCostumesUK:
				return "HalloweenCostumesUK";
				break;
			case this.ID.HalloweenCostumesAU:
				return "HalloweenCostumesAU";
				break;
			case this.ID.HalloweenCostumesEU:
				return "HalloweenCostumesEU";
				break;
			case this.ID.HalloweenCostumesMX:
				return "HalloweenCostumesMX";
				break;
			case this.ID.JokersMasqueradeGB:
				return "JokersMasqueradeGB";
				break;
			default:
				return "null";
				break;
		}
	}

	static get Type(): string
	{
		switch (this.DomainProjectID)
		{
			case this.ID.FancyDressCOM:
				return "FD";
				break;
			case this.ID.FunUS:
			case this.ID.FunAU:
			case this.ID.FunUK:
				return "Fun";
				break;
			case this.ID.HalloweenUS:
				return "HW";
				break;
			case this.ID.HalloweenCostumesUS:
			case this.ID.HalloweenCostumesCA:
			case this.ID.HalloweenCostumesUK:
			case this.ID.HalloweenCostumesAU:
			case this.ID.HalloweenCostumesEU:
			case this.ID.HalloweenCostumesMX:
				return "HC";
				break;
			case this.ID.JokersMasqueradeGB:
				return "JM";
				break;
			default:
				return "null";
				break;
		}
	}

	static SecureDomainUrl = "";

	static WebsiteName = "";
}